var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.c_isShowTimeAgo)?[_c('timeago',{attrs:{"datetime":_vm.datetime,"locale":"zh-CN","auto-update":60}})]:[_c('time',[_vm._v(_vm._s(new Date(_vm.datetime).toLocaleString('zh-CN')))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }